import Crud from '../views/ProductModel/Crud'
import Entity from '../views/ProductModel/Add'

let routes = {
    path: '/product_models',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/product_models/add',
            name: 'NewProductModel',
            component: Entity,
            meta: {
                pageTitle: 'Modelo',
                breadcrumb: [
                    { text: 'Modelo', active: false, to: '/product_models' },
                    { text: 'Adicionar Modelo', active: true }
                ],
            },
        },
        {
            path: '/product_models/edit/:id?',
            name: 'EditProductModel',
            component: Entity,
            meta: {
                pageTitle: 'Modelo',
                breadcrumb: [ 
                    { text: 'Modelo', active: false, to: '/product_models' },
                    { text: 'Editar Modelo', active: true }
                ],
            },
        },
        {
            path: '/product_models',
            name: 'list-product-models',
            component: Crud,
            meta: {
                pageTitle: '',
                breadcrumb: [
                    { text: 'Modelo', active: true },
                ],
            },
        },
    ]
};

export default routes
